import { render, staticRenderFns } from "./examCategory.vue?vue&type=template&id=616215a7&scoped=true&"
import script from "./examCategory.vue?vue&type=script&lang=js&"
export * from "./examCategory.vue?vue&type=script&lang=js&"
import style0 from "./examCategory.vue?vue&type=style&index=0&id=616215a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616215a7",
  null
  
)

export default component.exports